(ns app.front.view.group.admin.ai.core
  (:require [app.domain.group.model :as group-model]
            [app.front.ui :as ui]
            [app.front.ui.tabs :as ui-tabs]
            [app.front.view.group.admin.ai.configuration :as configuration]
            [app.front.view.group.admin.ai.files :as files]
            [app.front.view.group.admin.ai.rules :as rules]
            [app.front.view.group.admin.common :as acommon]
            [app.front.view.group.admin.subs :as gas]
            [clojure.string :as str]
            [core.front.event :refer [>evt <sub]]
            [core.front.feature-flags :as ff]
            [re-frame.core-instrumented :as rf]))

(def tabs [:group.ai-files/configuration-tab
           :group.ai-files/files-tab
           :group.ai-files/rules-tab])

(rf/reg-event-db ::select-tab
  (fn [db [_ tab]]
    (assoc db ::selected-tab tab)))

(rf/reg-sub ::selected-tab
  (fn [db]
    (or (::selected-tab db) (first tabs))))

(def rule-count-warning-threshold 30)

(defn rule-count-warnings [rules permit-types]
  (let [active-rules (filter #(= :active (:status %)) rules)]
    (keep #(let [product-id (name %)
                 rule-count (->> active-rules
                                 (filter (fn [{:keys [product-ids]}]
                                           (or (empty? product-ids)
                                               (some #{product-id} product-ids))))
                                 count)]
             (when (>= rule-count rule-count-warning-threshold)
               [% rule-count]))
          permit-types)))

(rf/reg-sub ::rule-count-warnings
  :<- [::rules/rules]
  :<- [::gas/group-permit-types]
  :<- [::gas/group]
  (fn [[rules permit-types group]]
    (rule-count-warnings (filter #(= (:group/id group) (:group-id %)) rules) permit-types)))

(defn rule-count-warning [tr]
  (let [warnings (<sub [::rule-count-warnings])
        group    (<sub [::gas/group])]
    (when (and (ff/enabled? :feature-flag.id/wizard-ai-precheck)
               (not (group-model/has-feature? group :group.feature/disable-ai-document-analysis))
               (seq warnings))
      [ui/warning
       (tr [:group.ai-files/precheck-rule-count-warning]
           [rule-count-warning-threshold
            (->> warnings
                 (map (fn [[permit-type rule-count]]
                        (tr [:group.ai-files/precheck-rule-count-warning-details]
                            [(tr [(keyword "permit-type" (name permit-type))]) rule-count])))
                 (str/join "\n"))])])))

(defn view [match]
  (let [tr             (<sub [::gas/group-tr])
        group-id       (<sub [::gas/group-id])
        selected-tab   (<sub [::selected-tab])
        available-tabs (cond-> []
                         (or (ff/enabled? :feature-flag.id/application-wizard)
                             (ff/enabled? :feature-flag.id/ai-settings-controls))
                         (conj :group.ai-files/configuration-tab)

                         :always
                         (conj :group.ai-files/files-tab)

                         (ff/enabled? :feature-flag.id/wizard-ai-precheck)
                         (conj :group.ai-files/rules-tab))
        selected-tab   (if ((set available-tabs) selected-tab)
                         selected-tab
                         (first available-tabs))]
    [acommon/admin-page-v2
     {:title               (tr [:view/group.admin.rag-files])
      :match               match
      :allowed-group-types #{:group.type/domain}
      :header-content      [:div
                            [ui-tabs/tabs
                             {:selected-id selected-tab
                              :aria-label  (tr [:view/group.admin.rag-files])
                              :on-change   #(>evt [::select-tab %])
                              :tabs        (for [tab available-tabs]
                                             {:id    tab
                                              :label (tr [tab])})}]
                            [rule-count-warning tr]]}
     [acommon/section-title-wrapper {:title (tr [selected-tab])}
      (case selected-tab
        :group.ai-files/configuration-tab [configuration/section tr]
        :group.ai-files/rules-tab         [rules/section tr group-id]
        [files/section tr group-id])]]))

(def route
  {:name        :view/group.admin.rag-files
   :view        view
   :own-layout? true
   :controllers [{:parameters {:path [:group-id]}
                  :start      (fn [{{:keys [group-id]} :path} _]
                                (>evt [::gas/fetch-authority-groups group-id])
                                (>evt [::files/list-files group-id])
                                (>evt [::rules/list-rules group-id]))}]})
